// extracted by css-extract-rspack-plugin
export default {"wrapper":"nzu2o","wrapper_debug":"CIYHJ","wrapperDebug":"CIYHJ","container":"XeAFn"};